import React from 'react';
import { Card, CardHeader, CardText, Checkbox, FontIcon } from 'material-ui';
import { connect } from 'react-redux';
import { getTemplateStatusColor } from '../contractingUtils';
import { push as pushAction } from 'react-router-redux';
import moment from 'moment';
import R from 'ramda';
import { Link } from 'react-router';
import StagedUpdatesText from '../generic-components/template-staged-updates-text-flag';
import pluralize from 'pluralize';

const SingleTemplate = props => {
  const {
    template,
    selectOrUnselect,
    style,
    makeItShorter,
    push,
  } = props;
  const state = template.state ? 'draft' : 'completed';
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...style,
      }}
    >
      {
        selectOrUnselect && (
          <Checkbox
            style={{ width: '50px' }}
            checked={Boolean(template.checked)}
            onCheck={() => selectOrUnselect({ id: template._id })}
          />
        )
      }
      <div
        style={{
          width: '55%',
          fontSize: '14px',
        }}
      >
        <div
          style={{ display: 'flex', alignItems: 'flex-center', cursor: 'pointer' }}
          onClick={() => push(`/contracting/${template.originalContractId ? 'draft' : 'template'}/${template.originalContractId || template._id}/details`)}
        >
          <FontIcon className="tc-icon-description" color="rgba(0, 0, 0, 0.54)" />
          {template.templateName}
        </div>
        {(() => {
          if (template.stagedUpdates && template.stagedUpdates.length) {
            return (
              <StagedUpdatesText
                style={{ fontSize: '12px' }}
                stagedUpdates={template.stagedUpdates}
                updateInitiated={template.updateInitiated}
                isEditedTemplate={template.templateHasDraft}
                refreshSection="list"
              />
            );
          }
          if (template.templateHasDraft) {
            return (
              <span style={{ marginLeft: '12px', color: 'red', zIndex: '200' }}>
                    This template has a{' '}
                <Link
                  onClick={e => e.stopPropagation()}
                  to={`/contracting/draft/${template._id}/details`}
                >
                      draft
                    </Link>
                    .
                  </span>
            );
          }
        })()}
      </div>
      {
        !R.isNil(template.partnersCount) && (
          <div
            style={{
              width: '70px',
              fontSize: '10px',
            }}
          >
            {template.partnersCount} {pluralize('partner', template.partnersCount)}
          </div>
        )
      }
      <div
        style={{
          width: '130px',
          fontSize: '10px',
        }}
      >
        {moment.utc(template.startDate).format('DD MMM YYYY')} - {moment.utc(template.endDate).format('DD MMM YYYY')}
      </div>
      <div
        style={{
          width: '65px',
          fontSize: '12px',
          textAlign: 'center',
          color: getTemplateStatusColor(state),
        }}
      >
        {state}
      </div>
      {
        !makeItShorter && (
          <div
            style={{
              fontSize: '12px',
              width: '65px',
              textAlign: 'right',
            }}
          >
            {moment(template.updatedAt).format('l')}
          </div>
        )
      }
    </div>
  );
};

const SimpleTemplateList = props => {
  const {
    templates,
    selectOrUnselect,
    isSingleLoc,
    makeItShorter,
    push,
  } = props;
  if (!(templates && templates.length)) {
    return <div>You don't have templates available.</div>;
  }
  if (isSingleLoc) {
    return (
      <div>
        {
          templates.map((template, templateIndex) => {
            return (
              <SingleTemplate
                key={templateIndex}
                template={template}
                selectOrUnselect={selectOrUnselect}
                makeItShorter={makeItShorter}
                style={{
                  padding: '16px',
                  borderBottom: '1px solid #e0e0e0',
                }}
              />
            );
          })
        }
      </div>
    );
  }
  const groupByLocations = R.groupBy(R.prop('locationName'), templates);
  const allLocNames = R.keys(groupByLocations);
  return (
    <div>
      {
        allLocNames.map((locName, locIndex) => (
          <Card
            key={`${locIndex}${locName}`}
            initiallyExpanded
            style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}
          >
            <CardHeader
              actAsExpander
              style={{ padding: '6px' }}
              showExpandableButton
              title={
                <div>
                  <FontIcon className="tc-icon-location_on" color="rgba(0, 0, 0, 0.54)" />
                  {locName || ''}
                </div>
              }
            />
            <CardText expandable>
              {groupByLocations[locName].map((obj, templateIndex) => (
                <SingleTemplate
                  key={templateIndex}
                  template={obj}
                  push={push}
                  selectOrUnselect={selectOrUnselect}
                  makeItShorter={makeItShorter}
                  style={{ marginBottom: '8px' }}
                />
              ))}
            </CardText>
          </Card>
        ))
      }
    </div>
  );
};

SimpleTemplateList.propTypes = {
  templates: React.PropTypes.array,
  selectOrUnselect: React.PropTypes.func,
  isSingleLoc: React.PropTypes.bool,
  makeItShorter: React.PropTypes.bool,
  push: React.PropTypes.func,
};

export default connect(({ user }) => {
  return {
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
  };
}, { push: pushAction })(SimpleTemplateList);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/simple-template-list.jsx